export enum Status {
	REJECTED = 'REJECTED',
	PENDING_APPROVAL = 'PENDING_APPROVAL',
	ACCEPTED = 'ACCEPTED',
}
